import _get from 'lodash/get';

let recentlyPromted = false;
let lastPromtedResponse = false;

// TODO (Volkan): ask Jess, there is an issue with this logic.
function handleRedirect ({ url, isSpoofed }) {
  if (isSpoofed && !recentlyPromted) {
    // eslint-disable-next-line no-alert
    lastPromtedResponse = window.confirm('Confirm redirect!');
    recentlyPromted = true;
  }

  if (lastPromtedResponse || !isSpoofed) {
    window.location.replace(url);
  }
}

export function PermissionExceptionInterceptor (error, $router, store) {
  const redirect = _get(error, 'response.data.errors[0].redirect');
  const url = _get(error, 'response.data.errors[0].url');
  const code = _get(error, 'response.data.errors[0].code');
  const message = _get(error, 'response.data.errors[0].message');
  const cta = _get(error, 'response.data.errors[0].full_cta');
  const header = _get(error, 'response.data.errors[0].header');


  if (redirect) {
    const { isSpoofed } = store.state.loginspoof;
    handleRedirect({ url, isSpoofed });
    return Promise.reject(error);
  }

  if (code && code.startsWith && code.startsWith('PERM-')) {
    store.commit('user/setIsBlocked', true);

    $router.replace({
      name: 'permission-exception',
      query: {
        message,
        cta,
        url,
        header,
        code,
      },
    });
  }

  return Promise.reject(error);
}

export function BadTokenInterceptor (error, store) {
  // TODO: come back and show warnings to users instead of loging them out nonchalantly.
  if (error.response && error.response.status === 401) {
    store.dispatch('user/logoutAndClearUserSession');
    window.location.href = '/error/401';
  } else {
    return Promise.reject(error);
  }
}

export default function interceptorSetup (http, router, store) {
  http.interceptors.response
    .use(null, error => PermissionExceptionInterceptor(error, router, store));
  http.interceptors.response.use(null, error => BadTokenInterceptor(error, store));
}
